<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormPriceList
      :PriceList="editPriceList"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormPriceList from '../components/FormPriceList.vue';

export default {
  components: {
    FormPriceList,
  },
  name: 'EditPriceList',
  module: 'PriceList',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing PriceList. Default to {}.
      */
      editPriceList: {},
      /**
       * Query Id for PriceList
       */
      priceListId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('priceLists', ['priceLists', 'priceList']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.priceListId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_suppliers();
    if (this.mode === 'edit') {
      await this.LOAD_priceList(this.priceListId);
      this.editPriceList = this.priceList;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('priceLists', ['LOAD_priceList', 'CREATE_priceList', 'UPDATE_priceList']),
    ...mapActions('suppliers', ['LOAD_suppliers']),
    /** Method used to save the item
     */
    async save(priceList) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_priceList(priceList);
      } else {
        await this.UPDATE_priceList(priceList);
      }
      this.isSaving = false;
      this.$router.push({ name: 'quotes-ListPriceList' });
    },
  },
};
</script>

<docs>
# EditPriceList example

'''js
<EditPriceList :PriceList="PriceList" />
'''
</docs>
